var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Copyright (C) Quantron Systems LLC.
//  All Rights Reserved.
//
//  This file is part of the private project.
//  For conditions of distribution and use,
//  please contact sales@quantron-systems.com
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useParams, useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { v4 as uuidv4 } from 'uuid';
import { useForm } from 'react-hook-form';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Row, Col, Form, Tabs, Tab, Modal, Panel } from '../../components/common/bootstrap';
import config from '../../api/config';
import { stationAPI } from '../../api/stationAPI';
import { TextInput, NumberInput, SelectInput } from '../../components/common/inputs';
import Spinner from '../../components/common/Spinner';
import BackgroundCard from '../../components/BackgroundCard';
import { partnerAPI } from '../../api/partnerAPI';
import { useAuth } from '../../hooks';
import { saveStationSchema } from './validations';
import BackgroundDownloadForm from './BackgroundDownloadForm';
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function Station(_a) {
    var _this = this;
    var isNew = _a.isNew;
    var _b = useParams().id, id = _b === void 0 ? '' : _b;
    var navigate = useNavigate();
    var _c = useAuth(), isAdmin = _c.isAdmin, userId = _c.userId;
    var _d = __read(useState({ photo: {}, id: '', activeKey: '', show: false }), 2), editingPhoto = _d[0], setEditingPhoto = _d[1];
    var _e = __read(useState(true), 2), skipGetStation = _e[0], setSkipGetStation = _e[1];
    var _f = __read(useState(false), 2), visibleUploadForm = _f[0], setVisibleUploadForm = _f[1];
    var _g = __read(useState('station'), 2), activeKey = _g[0], setActiveKey = _g[1];
    var _h = __read(useState(false), 2), copied = _h[0], setCopied = _h[1];
    var _j = __read(useState(), 2), stationOwnerInfo = _j[0], setStationOwnerInfo = _j[1];
    var _k = __read(stationAPI.useSaveStationMutation(), 1), saveStation = _k[0];
    var station = stationAPI.useGetStationQuery(id, { skip: skipGetStation });
    var _l = partnerAPI.useGetOwnerListQuery('').data, data = _l === void 0 ? [] : _l;
    var stationData = station.data;
    var stationName = _.get(stationData, 'name', '');
    var stationBackgrounds = _.get(stationData, 'backgrounds', []);
    var _m = useForm({
        resolver: yupResolver(saveStationSchema)
    }), register = _m.register, handleSubmit = _m.handleSubmit, reset = _m.reset, setValue = _m.setValue, errors = _m.formState.errors;
    var generateStationId = function () {
        var id = uuidv4();
        setValue('id', id);
    };
    var handleSaveStation = function (_a) {
        var name = _a.name, registryNumber = _a.registryNumber, ownerAuthKeyId = _a.ownerAuthKeyId, id = _a.id;
        return __awaiter(_this, void 0, void 0, function () {
            var result, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(name && registryNumber && ownerAuthKeyId && id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, saveStation({
                                id: id,
                                ownerAuthKeyId: ownerAuthKeyId,
                                name: name,
                                registryNumber: _.toString(registryNumber)
                            })];
                    case 1:
                        result = _b.sent();
                        error = _.get(result, 'error');
                        if (isNew && !error) {
                            navigate("/stations/".concat(id));
                            setSkipGetStation(false);
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    var handleClose = function () { return setEditingPhoto({ photo: {}, id: '', activeKey: '', show: false }); };
    var renderForm = function () { return (_jsx(_Fragment, { children: _jsxs(Form, __assign({ onSubmit: handleSubmit(handleSaveStation) }, { children: [_jsx(Row, { children: _jsx(Col, __assign({ md: 4 }, { children: _jsxs(Form.Group, { children: [_jsx(TextInput, { register: register, name: 'name', errors: errors, label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u0442\u0430\u043D\u0446\u0438\u0438' }, void 0), _jsx(NumberInput, { register: register, name: 'registryNumber', errors: errors, label: '\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u0442\u0430\u043D\u0446\u0438\u0438' }, void 0), isNew && _jsxs("div", __assign({ className: 'mb-2' }, { children: [_jsx(TextInput, { register: register, name: 'id', errors: errors, label: '\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440' }, void 0), _jsx(Button, __assign({ variant: 'info', onClick: generateStationId }, { children: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }), void 0)] }), void 0), _jsx(SelectInput, { register: register, name: 'ownerAuthKeyId', optionName: 'owner', errors: errors, label: '\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0441\u0442\u0430\u043D\u0446\u0438\u0438', values: data, disabled: !isAdmin }, void 0)] }, void 0) }), void 0) }, void 0), _jsx(Row, { children: _jsx(Col, __assign({ md: 4 }, { children: _jsx("div", __assign({ className: 'text-right' }, { children: _jsx(Button, __assign({ variant: 'primary', type: 'submit' }, { children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), void 0) }), void 0) }), void 0) }, void 0)] }), void 0) }, void 0)); };
    useEffect(function () {
        if (!isNew) {
            setSkipGetStation(!skipGetStation);
        }
    }, []);
    useEffect(function () {
        if (stationData) {
            var name_1 = stationData.name, registryNumber = stationData.registryNumber, owner_1 = stationData.owner, id_1 = stationData.id;
            var stationOwnerInfo_1 = _.find(data, function (obj) { return (obj === null || obj === void 0 ? void 0 : obj.id) == (owner_1 === null || owner_1 === void 0 ? void 0 : owner_1.id); });
            setStationOwnerInfo(stationOwnerInfo_1);
            reset({
                name: name_1,
                registryNumber: registryNumber,
                ownerAuthKeyId: owner_1 === null || owner_1 === void 0 ? void 0 : owner_1.id,
                id: id_1
            });
        }
        if (isNew) {
            reset({
                name: '',
                registryNumber: '',
                ownerAuthKeyId: !isAdmin ? userId : '',
                id: ''
            });
        }
    }, [stationData, data]);
    var publicStationPhotosHash = _.get(stationOwnerInfo, 'publicStationPhotosHash');
    var maskType = _.get(stationOwnerInfo, 'maskType', '');
    var labelText = isNew ? 'Новая станция' : "\u0421\u0442\u0430\u043D\u0446\u0438\u044F: ".concat(stationName);
    var publicUploadUrlParams = new URLSearchParams({ maskType: maskType });
    var publicUploadUrl = "".concat(config.photoAppUrl, "/#/stations/").concat(publicStationPhotosHash, "?").concat(publicUploadUrlParams.toString());
    return (_jsxs(_Fragment, { children: [_jsx("h4", { children: labelText }, void 0), _jsxs(Tabs, __assign({ activeKey: activeKey, onSelect: function (key) { return key && setActiveKey(key); }, className: 'mb-3' }, { children: [_jsx(Tab, __assign({ eventKey: 'station', title: '\u0421\u0442\u0430\u043D\u0446\u0438\u044F' }, { children: renderForm() }), void 0), id && _jsxs(Tab, __assign({ eventKey: 'backgrounds', title: '\u0424\u043E\u043D\u044B \u0441\u0442\u0430\u043D\u0446\u0438\u0439' }, { children: [_jsxs(Row, __assign({ className: 'mb-3' }, { children: [_jsx(Col, __assign({ md: 4 }, { children: _jsxs("div", __assign({ className: 'd-flex align-items-center' }, { children: [_jsx("a", __assign({ href: publicUploadUrl, target: '_blank', className: 'btn btn-link', rel: 'noreferrer' }, { children: "\u0421\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0444\u043E\u043D\u043E\u0432 \u0441\u0442\u0430\u043D\u0446\u0438\u0438" }), void 0), _jsx("span", __assign({ className: 'ml-1' }, { children: "(\u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F)" }), void 0)] }), void 0) }), void 0), _jsx(Col, __assign({ md: 2 }, { children: _jsx(CopyToClipboard, __assign({ text: publicUploadUrl, onCopy: function () { return setCopied(true); } }, { children: _jsx("div", __assign({ className: 'd-flex align-items-center h-100' }, { children: _jsx(Button, __assign({ variant: 'info', size: 'sm', className: 'w-100' }, { children: copied ? 'Скопировано' : 'Скопировать ссылку' }), void 0) }), void 0) }), void 0) }), void 0)] }), void 0), _jsx("hr", { className: 'sidebar-divider d-none d-md-block' }, void 0), _jsx(Row, __assign({ className: 'mb-3' }, { children: _jsx(Col, { children: _jsx(Button, __assign({ variant: 'primary', onClick: function () { return setVisibleUploadForm(true); } }, { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u043D" }), void 0) }, void 0) }), void 0), _jsx(Row, { children: _.map(stationBackgrounds, function (photo) { return _jsx(Col, __assign({ md: 2 }, { children: _jsx(BackgroundItem, { stationId: id, photo: photo, onClick: function () { return setEditingPhoto({ photo: photo, id: id, activeKey: activeKey, show: true }); } }, void 0) }), photo.selectelFileId); }) }, void 0), visibleUploadForm &&
                                _jsx(BackgroundDownloadForm, { onHide: function () { return setVisibleUploadForm(false); } }, void 0), editingPhoto.show &&
                                _jsx(BackgroundModal, { photo: editingPhoto.photo, stationId: editingPhoto.id, activeKey: editingPhoto.activeKey, showModal: editingPhoto.show, handleClose: handleClose }, void 0)] }), void 0)] }), void 0)] }, void 0));
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function BackgroundModal(_a) {
    var handleClose = _a.handleClose, photo = _a.photo, stationId = _a.stationId, activeKey = _a.activeKey, showModal = _a.showModal;
    return _jsxs(Modal, __assign({ show: showModal, onHide: handleClose, size: 'lg' }, { children: [_jsx(Modal.Header, __assign({ closeButton: true }, { children: _jsx(Modal.Title, { children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0447\u0435\u043A" }, void 0) }), void 0), _jsx(Modal.Body, { children: _jsx(BackgroundCard, { photo: photo, stationId: stationId, activeKey: activeKey, handleClose: handleClose }, void 0) }, void 0)] }), void 0);
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function BackgroundItem(_a) {
    var photo = _a.photo, stationId = _a.stationId, onClick = _a.onClick;
    var _b = __read(useState(''), 2), previewUrl = _b[0], setPreviewUrl = _b[1];
    var previewBody = {
        id: stationId, category: photo.category, side: photo.side, preview: true
    };
    var _c = stationAPI.useGetPreviewQuery(previewBody), data = _c.data, isLoading = _c.isLoading;
    useEffect(function () {
        if (data) {
            setPreviewUrl(URL.createObjectURL(data));
        }
    }, [data]);
    return _jsx(Panel, { children: _jsxs("div", __assign({ onClick: onClick, className: 'station__background-item' }, { children: [isLoading ? _jsx("div", __assign({ className: 'station__background-img' }, { children: _jsx(Spinner, {}, void 0) }), void 0)
                    : _jsx("img", { src: previewUrl, alt: 'image', className: 'w-100' }, void 0), _jsx("hr", { className: 'sidebar-divider d-none d-md-block' }, void 0), _jsxs("div", { children: [_jsxs("div", __assign({ className: 'mb-2' }, { children: ["\u0412\u0438\u0434: ", photo.side === 'Front' ? 'Спереди' : 'Сзади'] }), void 0), _jsxs("div", { children: ["\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F: ", photo.category] }, void 0)] }, void 0)] }), void 0) }, void 0);
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default Station;
